/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { UploadType } from "./upload-type";

export class UploadState {
    id: number;
    created: Date = new Date("18/11/2020 17:13:12");
    fileName: string;
    uploader: string;
    type: UploadType;
    mediaLink: string;
    siteId: number;
    jobId: number;
    systemId: number;
    rotation: number;
}
